import React, { forwardRef, useEffect, useState } from 'react'
import { Select } from '@ow/comps'
import { useTheme } from '@ow/theme'
import { isArray } from 'lodash-es'

export const customStyles = (controlStyle) => {
  return {
    input: (styles) => ({ ...styles }),
    control: (styles, { isFocused }) => ({
      ...styles,
      ...controlStyle,
      borderBottomLeftRadius: '0',
      borderTopLeftRadius: '0',
      height: '34px',
      minHeight: '34px',
      backgroundColor: '#fff',
      borderColor: isFocused
        ? 'rgb(var(--ow-primary-color)) !important'
        : '#dbdfea',
      boxShadow: isFocused
        ? '0 0 0 3px rgba(var(--ow-primary-color),.10)'
        : 'none',
      ':active': {
        ...styles[':active'],
        borderColor: 'rgb(var(--ow-primary-color))',
        borderBottomLeftRadius: '0px',
      },
      ':hover': {
        ...styles[':hover'],
        borderColor: 'rgb(var(--ow-border-color))',
      },
    }),
    indicatorSeparator: (styles) => ({
      ...styles,
      width: '0',
    }),
    indicatorsContainer: (styles) => ({
      ...styles,
    }),
    placeholder: (styles) => ({
      ...styles,
      fontSize: '0.8125rem',
      color: 'var(--ow-color-gray-300)',
    }),
    valueContainer: (styles) => ({
      ...styles,
      flexWrap: 'nowrap',
      padding: '0',
      fontSize: '0.8125rem',
    }),
    menu: (styles) => ({
      ...styles,
      background: '#ffffff',
      borderRadius: '2px',
      boxShadow: '0px 3px 12px 0px rgba(var(--ow-primary-color),0.1)',
      marginTop: '4px',
      marginBottom: '0',
      zIndex: '1000',
    }),
    menuList: (styles) => ({
      ...styles,
      pdddingTop: '0',
    }),
    option: (styles, { isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected ? '#ebeef2' : '#fff',
        width: '100%',
        color: '#526484',
        padding: '6px 12px',
        borderRadius: '4px',
        fontSize: '0.8125rem',
        ':active': {
          ...styles[':active'],
          backgroundColor: '#ebeef2',
        },
      }
    },
  }
}

// style 为 control的样式
export default forwardRef(
  ({ opts = {}, value, style, onFetchRemoteData, onChange }, ref) => {
    const { boxShadow } = useTheme()
    const [options, setOptions] = useState([])

    useEffect(() => {
      /** 如果视图配置了从接口中获取数据 */
      if (onFetchRemoteData && opts.remote && opts.remote.api) {
        const api = onFetchRemoteData('ExtendModel')
        /** opts.remote.api: 接口的名称 */
        api[opts.remote.api]().then((res) => {
          setOptions(
            (res || []).map((option) => {
              return { ...option, label: option.title }
            })
          )
        })
      } else {
        const selects = (opts.selects || []).map((option) => {
          return { ...option, label: option.title }
        })
        setOptions(selects)
      }
    }, [])

    const defaultValue = options.filter((item) => {
      if (opts.multiple) {
        return value && value.includes(item.slug) && item
      }
      if (isArray(item.slug)) {
        return value && value[0] === item.slug[0]
      }
      return item.slug === value
    })
    console.log(value, defaultValue, 'defaultValue')
    return (
      <Select
        ref={ref}
        multi={opts.multiple}
        options={options || []}
        styles={customStyles(style, boxShadow)}
        onChange={(e) => {
          if (opts.multiple) {
            const arr = (e || []).map((item) => item.slug)
            onChange(arr)
          } else if (e) {
            const { slug } = e
            onChange(slug)
          } else {
            onChange(null)
          }
        }}
        placeholder={opts.hint || `请选择${opts.title}`}
        value={defaultValue}
        noOptionsMessage={() => '暂无数据'}
      />
    )
  }
)
